import { Component, Inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { DropdownModule } from 'primeng/dropdown';
import { ResultService } from '../../pages/enter-claims-la/result/result.service';
import { IraResultService } from '../../pages/ira-result/ira-result.service';

@Component({
  selector: 'app-ira-alert-popup',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    NgIf,
    NgFor,
    NgClass,
    DropdownModule,
  ],

  templateUrl: './ira-alert-popup.component.html',
  styleUrl: './ira-alert-popup.component.scss',
})
export class IraAlertPopupComponent {
  selectedGeography: any = [];
  geographyNamesData: any = [];
  selectedTranslationLanguage: any = [];
  geographyData: any;
  selection = new SelectionModel<any>(true, []);
  selectedGeographiesData: any = [];
  urlDomain: any;
  projectId: any;
  fileDetails: any;
  responseData: any;
  marketingChannels: any;
  routeFrom: any;
  isDraftData: any;
  resultData: any;
  navigatedFrom: any;
  iraConfirm: any;
  redirectFrom: any;
  fromConfirmPopup: any;
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<IraAlertPopupComponent>,
    public router: Router,
    private resultService: ResultService,
    public iraResultService: IraResultService,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.geographyData = data.geographyData;
    console.log(' this.geographyData', this.geographyData);
    localStorage.removeItem('geographypopup');
    localStorage.removeItem('geographyNamepopup');
    console.log('data', this.data);
    if (data.messageType == 'ConfirmPopup') {
      this.responseData = this.data.resultPageData;
      this.fileDetails = this.data.fileDetails;
      this.marketingChannels = this.data.marketingChannels;
      this.routeFrom = this.data.routeFrom;
      this.isDraftData = this.data.draftData;
      this.resultData = this.data.resultData;
      this.navigatedFrom = this.data.navigatedFrom;
      this.iraConfirm = this.data.iraConfirm;
      this.redirectFrom = this.data.redirectFrom;
      this.fromConfirmPopup = this.data.fromConfirmPopup;
    }
    console.log('routeFrom', this.routeFrom);
    console.log(this.iraConfirm, 'this.iraConfirm');
  }

  ngOnInit() {
    this.urlDomain = localStorage.getItem('urlDomain');
    this.projectId = localStorage.getItem('project');
  }

  oncancelClick() {
    this.dialogRef.close(false);
  }

  onConfirmClick() {
    this.confirmGeographyPopup();
    //this.dialogRef.close(true); // This will return `true` to the parent
  }

  onConfirm() {
    this.dialogRef.close(true); // This will return `true` to the parent
  }

  // navigate(buttonId) {
  //   if (buttonId == 'bulk') {
  //     this.router.navigate(['/home']);
  //   } else if (buttonId == 'roject') {
  //     this.router.navigate(['/home']);
  //   } else if (buttonId == 'edit') {
  //     this.router.navigate(['/edit-claims-la']);
  //   } else if (buttonId == 'continue') {
  //     this.router.navigate(['/result']);
  //   }
  //   this.dialogRef.close(buttonId);
  // }

  navigate(buttonId) {
    if (buttonId == 'bulk') {
      this.router.navigate(['/home']);
    } else if (buttonId == 'project') {
      // this.router.navigate(['/home']);
      window.location.href =
        'https://' +
        this.urlDomain +
        '/ui/#t/0TB000000000733/V2C/' +
        this.projectId;
    } else if (buttonId == 'edit') {
      //this.resultService.setSupportSubstantiationRedirect(true);
      console.log('false from popup edit claim');
      this.router.navigate(['/editclaims']);
    } else if (buttonId == 'continue') {
      if (
        this.routeFrom == 'editClaims' &&
        this.redirectFrom != 'substantiation-confirmation'
      ) {
        console.log(this.navigatedFrom, 'this.navigatedFrom');
        console.log('brfore edit responseData from ira', this.responseData);
        console.log('before edit fileDetails from ira', this.fileDetails);
        if (
          this.routeFrom == 'editClaims' &&
          this.navigatedFrom == 'confirm' &&
          this.iraConfirm != 'NO'
        ) {
          console.log('After Edit responseData from ira', this.responseData);
          console.log('After Edit fileDetails from ira', this.fileDetails);
          this.iraResultService.setiraConfirmChanges(true);

          this.router.navigate(['/result'], {
            state: {
              data: this.responseData,
              fileDetails: [{}],
              isExcel: false,
              //routeFrom: this.routeFrom,
              // routeFrom: 'editClaims',
              // source: 'Draft',
              // pageFrom: 'ira',
              // navigatedFrom: 'confirm',
              pageFrom: 'ira',
              source: 'Draft',
              navigatedFrom: 'confirm',
              routeFrom: 'editClaims',
              fromConfirmPopup: this.fromConfirmPopup,
            },
          });
        } else {
          // this.resultService.setSupportSubstantiationRedirect(true);
          console.log('false from popup result edit claim');
          // this.router.navigate(['/editclaims']);

          console.log('this.responseData', this.responseData);

          // const filteredData = this.responseData.map((item: any) => {
          //   return {
          //     ...item,
          //     edit_la: item.edit_la.filter((row: any) => row.highlighted !== true)
          //   };
          // });

          const filteredData = this.responseData.map((item: any) => {
            const filteredEditLa = item.edit_la
              .filter((row: any) => row.highlighted !== true)
              .map((row: any, index: number) => ({
                ...row,
                slno: index + 1, // Reassign slno starting from 1
                sr_no: (index + 1).toString().padStart(2, '0'), // Optional: update sr_no as well
              }));

            return {
              ...item,
              edit_la: filteredEditLa,
            };
          });

          console.log('filteredData', filteredData);

          this.router.navigate(['editclaims'], {
            state: {
              data: filteredData,
              fileDetails: this.fileDetails,
              isExcel: false,
              routeFrom: this.routeFrom,
              source: this.isDraftData,
            },
          });
        }
      } else if (this.routeFrom == 'ira') {
        console.log('responseData', this.responseData);
        console.log('fileDetails', this.fileDetails);
        this.iraResultService.setiraConfirmChanges(true);
        this.router.navigate(['/result'], {
          state: {
            data: this.responseData,
            isExcel: false,
            fileDetails: this.fileDetails,
            marketingChannel: this.marketingChannels,
            pageFrom: 'ira',
            source: this.isDraftData,
          },
        });
      } else if (this.redirectFrom == 'substantiation-confirmation') {
        console.log('responseData', this.responseData);
        console.log('fileDetails from ira confirm popup', this.fileDetails);
        console.log('response data deom sub confirm', this.responseData);

        console.log('this.resultData data deom sub confirm', this.resultData);

        this.router.navigate(['/result'], {
          state: {
            data: this.responseData,
            isExcel: false,
            fileDetails: this.fileDetails,
            marketingChannel: this.marketingChannels,
            pageFrom: 'substantiation-confirmation',
            source: this.isDraftData,
            responseData: this.resultData,
            editIrarouteFrom: this.routeFrom === 'editClaims' ? 'ira' : '',
          },
        });
      } else {
        this.router.navigate(['/result'], {
          state: {
            data: this.responseData,
            isExcel: false,
            fileDetails: this.fileDetails,
            marketingChannel: this.marketingChannels,
            source: this.isDraftData,
          },
        });
      }
    }
    this.dialogRef.close(buttonId);
  }

  geographyvaluechange(event: any) {
    //const geogrpahy = event.source.triggerValue.split(', ');
    console.log('event', event.value);
    const geography = event.value;
    this.selectedGeography = event.value;
    this.geographyNamesData.push(geography);
  }

  confirmGeographyPopup() {
    console.log('selectedGeography', this.selectedGeography);
    console.log('geographyNamesData', this.geographyNamesData);
    localStorage.setItem('geographypopup', this.selectedGeography);
    localStorage.setItem('geographyNamepopup', this.geographyNamesData);

    // Find the selected geography object
    const selectedGeographyObj = this.geographyData.find(
      (value) => value.country__v === this.selectedGeography
    );
    console.log('selectedGeographyObj', selectedGeographyObj);
    // Extract the geography name
    const geographyName = selectedGeographyObj?.country_name || '';
    console.log('geographyName', geographyName);

    // Store in localStorage
    localStorage.setItem('geographypopup', this.selectedGeography);
    localStorage.setItem('geographyNamepopup', geographyName);

    this.selectedGeographiesData = this.geographyData.filter((value, i) => {
      return value.country__v == this.selectedGeography;
    });
    this.dialogRef.close(this.selectedGeographiesData);
  }
}
